<template>
  <div class="q-mt-xl container">
    <div class="col-12">
      <div>
        <q-linear-progress
          size="xs"
          class="q-mt-sm"
          v-if="loading"
          indeterminate
        />

        <q-table
          :grid="$q.screen.lt.sm"
          :rows="listaProdutos"
          color="primary"
          :columns="columns"
          selection="multiple"
          dense
          row-key="code"
          :class="{ 'my-sticky-dynamic': !mobile }"
          flat
          hide-pagination
          :loading="loading"
          v-model:pagination="pagination"
          v-model:selected="selected"
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-right>
            <div class="row q-gutter-sm">
              <div>
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtrarProduto"
                  type="text"
                  placeholder="Pesquisar"
                >
                  <template v-slot:append>
                    <q-icon name="search" />
                  </template>
                </q-input>
              </div>
              <div v-if="temPermissaoBuscaCA()">
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  v-model="filtroCACodigo"
                  type="text"
                  placeholder="Código CA"
                >
                  <template v-slot:append>
                    <q-icon name="badge" />
                  </template>
                </q-input>
              </div>
              <div v-if="temPermissaoBuscaCA()">
                <q-select
                  rounded
                  outlined
                  dense
                  v-model="filtroCAStatus"
                  option-value="value"
                  option-label="label"
                  label="Status CA"
                  :options="[
                    { label: 'Todos', value: '' },
                    { label: 'Válido', value: 'Válido' },
                    { label: 'Vencido', value: 'Vencido' },
                  ]"
                  style="min-width: 240px"
                >
                  <template v-slot:append>
                    <q-icon name="verified" />
                  </template>
                </q-select>
              </div>
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Selecione os Produtos para Requisição
            </span>
          </template>
          <template v-slot:item="props">
            <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
              <div class="row card">
                <div class="col-3 q-mr-sm text-center q-mt-md">
                  <div
                    v-if="props.row.product_images.length != 0"
                    class="img-container-grid q-ml-sm"
                  >
                    <q-img
                      v-if="props.row.product_images.length != 0"
                      :src="props.row.product_images[0].url"
                      fit="contain"
                      class="img-grid"
                    />
                  </div>
                  <div class="img-container-grid q-ml-sm" v-else>
                    <span class="img-grid"></span>
                  </div>
                </div>
                <div class="col">
                  <q-card-section class="row text-brand-5 text-grid-table">
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Código:</strong> {{ props.row?.code }}</span
                      >
                      <span class="q-ml-sm"
                        ><strong>Nome:</strong>
                        {{
                          props.row?.pivot &&
                          props.row?.pivot.contract_product_description
                            ? props.row?.pivot.contract_product_description
                            : props.row?.name
                        }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>CA:</strong> {{ props.row.ca_codigo }}</span
                      >
                    </div>

                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Endereço:</strong>
                        {{ props.row.endereco }}</span
                      >
                    </div>
                    <div class="col-12" style="margin-bottom: 3px">
                      <span
                        ><strong>Estoque:</strong>
                        {{
                          parseInt(props.row?.stock[0]?.pivot?.amount).toFixed(
                            2
                          )
                        }}</span
                      >
                    </div>
                    <q-td v-if="filtroTipoRequisicao == 'liberados'">
                      {{ compararData(props.row, props.row.pode_retirar) }}
                    </q-td>
                    <div class="col-12">
                      <div class="col-12">
                        <div class="text-brand-5 btn-grid-container">
                          <div class="row col-12 items-center">
                            <div class="q-mr-sm">
                              <p></p>
                              <q-icon
                                name="arrow_left"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount != null &&
                                  props.row.amount > 0
                                    ? props.row.amount--
                                    : ''
                                "
                              />
                            </div>
                            <div
                              class="row col-2 justify-center input-quantidade-container"
                              style="border-bottom: 1px solid #505050"
                            >
                              <q-input
                                class="input-quantidade"
                                borderless
                                dense
                                type="number"
                                v-model="props.row.amount"
                                min="0"
                              />
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <q-icon
                                name="arrow_right"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount == null
                                    ? (props.row.amount = 1)
                                    : props.row.amount++
                                "
                              />
                            </div>
                            <div class="q-ml-md">
                              <p></p>
                              <q-btn
                                :text-color="props.selected ? 'black' : ''"
                                :color="props.selected ? 'accent' : 'primary'"
                                label="Selecionar"
                                :loading="props.row.loadingButton"
                                @click="
                                  $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                                    'voucher-aviso-regra'
                                  ) == -1
                                    ? (props.selected = !props.selected)
                                    : filtroTipoRequisicao == 'liberados'
                                    ? verificarQuantidade(props.row, props)
                                    : verificarQuantidadeHttp(
                                        props.row,
                                        props,
                                        (props.row.loadingButton = true)
                                      )
                                "
                                :disable="props.selected"
                                no-caps
                                dense
                                size="11px"
                                :icon="
                                  props.selected
                                    ? 'check_circle_outline'
                                    : 'add_circle_outline'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                <span v-if="filtroTipoRequisicao == 'liberados'">{{
                  col.label
                }}</span>
                <span v-else>{{
                  col.label == "Pode Retirar (S/N)" ||
                  col.label == "Critico" ||
                  col.label == "Endereço"
                    ? ""
                    : col.label
                }}</span>
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <q-btn
                  class="q-ml-md"
                  :color="props.selected ? 'red' : 'secondary'"
                  round
                  no-caps
                  dense
                  :loading="props.row.loadingButton"
                  :icon="props.selected ? 'close' : 'add'"
                  @click="
                    $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                      'voucher-aviso-regra'
                    ) == -1 && r
                      ? (props.selected = !props.selected)
                      : filtroTipoRequisicao == 'liberados'
                      ? verificarQuantidade(props.row, props)
                      : requisicaoPara == 'visitante'
                      ? verificarQuantidade(props.row, props)
                      : verificarQuantidadeHttp(
                          props.row,
                          props,
                          (props.row.loadingButton = true)
                        )
                  "
                />
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <div
                  v-if="props.row.product_images.length != 0"
                  class="img-container"
                >
                  <q-img
                    v-if="props.row.product_images.length != 0"
                    :src="props.row.product_images[0].url"
                    fit="contain"
                    style="max-width: 100%; height: 45px"
                  />
                </div>
                <div class="img-container" v-else>
                  <span class="img-normal"></span>
                </div>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row?.code }}</span>
              </q-td>
              <q-td
                style="white-space: normal"
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{
                  props.row?.pivot &&
                  props.row?.pivot.contract_product_description
                    ? props.row?.pivot.contract_product_description
                    : props.row?.name
                }}</span>
                <span
                  class="q-ml-sm"
                  v-if="
                    props.row.critico == 1 && compararDataCritico(props.row)
                  "
                >
                  (Atenção, a não retirada deste item está BLOQUEANDO a retirada
                  de todos os outros itens. )</span
                >
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.ca_codigo }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <div v-if="props.row.ca_status || props.row.pivot?.ca?.status">
                  <div
                    v-if="
                      (props.row.ca_status || props.row.pivot?.ca?.status) ==
                      'Válido'
                    "
                    class="row align items-center"
                    style="
                      width: fit-content;
                      background: #e8ffec;
                      padding: 2px 5px;
                    "
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div
                      style="width: fit-content"
                      class="text-bold text-brand-5"
                    >
                      {{ props.row.ca_status || props.row.pivot?.ca?.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="
                      width: fit-content;
                      background: #ffe9e9;
                      padding: 2px 5px;
                    "
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div
                      style="width: fit-content; color: #850202"
                      class="text-bold"
                    >
                      {{ props.row.ca_status || props.row.pivot?.ca?.status }}
                    </div>
                  </div>
                </div>
                <span v-else>-</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{ props.row.endereco }}</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span v-if="props.row.critico == 1">Sim</span>
                <span v-if="props.row.critico == 0"> Não</span>
              </q-td>
              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{
                  parseInt(props.row?.stock[0]?.pivot?.amount).toFixed(2)
                }}</span>
              </q-td>

              <q-td
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <div>
                  <q-input
                    v-model.number="props.row.amount"
                    type="number"
                    style="width: 60px; max-width: 100px"
                    min="0"
                    outlined
                    dense
                  />
                </div>
              </q-td>
              <q-td
                v-if="filtroTipoRequisicao == 'liberados'"
                :style="{
                  'background-color':
                    props.row.critico == 1 && compararDataCritico(props.row)
                      ? '#FBA6B4'
                      : '',
                }"
              >
                <span>{{
                  compararData(props.row, props.row.pode_retirar)
                }}</span>
              </q-td>
            </q-tr>
            <q-tr
              :style="{
                'background-color':
                  props.row.critico == 1 && compararDataCritico(props.row)
                    ? '#FBA6B4'
                    : '',
              }"
              v-if="props.row.critico == 1 && compararDataCritico(props.row)"
              style="color: white"
              :props="props"
              :key="`e_${props.row.index}`"
              class="q-virtual-scroll--with-prev"
            >
              <q-td colspan="100%">
                <div class="text-left">
                  (Atenção, a não retirada deste item está BLOQUEANDO a retirada
                  de todos os outros itens. )
                </div>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <div class="row justify-start q-mt-md">
          <q-pagination
            :disable="disable"
            v-model="pagination.page"
            color="brand-5"
            active-color="secondary"
            active-text-color="white"
            :max="pagesNumber"
            :direction-links="true"
            size="sm"
            :max-pages="6"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl q-mb-lg" v-if="selected.length > 0">
      <q-table
        :grid="$q.screen.lt.sm"
        table-header-class="bg-accent text-width-bold"
        :columns="columns2"
        class="tabela-tamanho-fixo"
        :rows="selected"
        no-data-label="Nenhuma produto encontrado."
        hide-pagination
        :rows-per-page-options="[0]"
        :class="{ 'my-sticky-dynamic': !mobile }"
        dense
        flat
      >
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos Selecionados</span
          >
        </template>

        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-6 col-md-4">
            <div class="row card">
              <div class="col-3 q-mr-sm text-center q-mt-md">
                <div
                  v-if="props.row.product_images.length != 0"
                  class="img-container-grid q-ml-sm"
                >
                  <q-img
                    v-if="props.row.product_images.length != 0"
                    :src="props.row.product_images[0].url"
                    fit="contain"
                    class="img-grid"
                  />
                </div>
                <div class="img-container-grid q-ml-sm" v-else>
                  <span class="img-grid"></span>
                </div>
              </div>
              <div class="col">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12" style="margin-bottom: 3px">
                    <span><strong>Código:</strong> {{ props.row?.code }}</span>
                    <span class="q-ml-sm"
                      ><strong>Nome:</strong>
                      {{
                        props.row?.pivot &&
                        props.row?.pivot.contract_product_description
                          ? props.row?.pivot.contract_product_description
                          : props.row?.name
                      }}</span
                    >
                  </div>
                  <div class="col-12" style="margin-bottom: 3px">
                    <span><strong>CA:</strong> {{ props.row.ca_codigo }}</span>
                  </div>
                  <div class="col-12" style="margin-bottom: 3px">
                    <span
                      ><strong>Estoque:</strong>
                      {{
                        parseInt(props.row.stock[0]?.pivot?.amount).toFixed(2)
                      }}</span
                    >
                  </div>
                  <div class="col-12">
                    <div class="col-12">
                      <div class="text-brand-5 btn-grid-container">
                        <div class="row col-12 items-center">
                          <div class="q-mr-sm">
                            <p></p>
                            <q-icon
                              name="arrow_left"
                              class="arrow"
                              style="background: #6391f4"
                              @click="
                                props.row.amount != null && props.row.amount > 0
                                  ? props.row.amount--
                                  : ''
                              "
                            />
                          </div>
                          <div
                            class="row col-2 justify-center input-quantidade-container"
                            style="border-bottom: 1px solid #505050"
                          >
                            <q-input
                              class="input-quantidade"
                              borderless
                              dense
                              type="number"
                              v-model="props.row.amount"
                              min="0"
                            />
                          </div>
                          <div class="q-ml-sm">
                            <p></p>
                            <div class="arrow-container">
                              <q-icon
                                name="arrow_right"
                                class="arrow"
                                style="background: #6391f4"
                                @click="
                                  props.row.amount == null
                                    ? (props.row.amount = 1)
                                    : props.row.amount++
                                "
                              />
                            </div>
                          </div>
                          <div class="row col justify-center q-ml-xl">
                            <div>
                              <p></p>
                              <q-icon
                                name="close"
                                style="
                                  font-size: 28px;
                                  margin: 0px 0px 3px 0px;
                                  cursor: pointer;
                                "
                                color="red"
                                @click="removerProduto(props.row.id)"
                              ></q-icon>
                            </div>
                            <div class="q-ml-sm">
                              <p></p>
                              <q-icon
                                name="manage_search"
                                style="
                                  font-size: 28px;
                                  margin: 0px 0px 3px 0px;
                                  cursor: pointer;
                                "
                                color="black"
                                @click="
                                  (item = {
                                    nome: props.row.name,
                                    id: props.row.code,
                                  }),
                                    atualizarHistorico++
                                "
                              ></q-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </q-card-section>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              <span v-if="filtroTipoRequisicao == 'liberados'">{{
                col.label
              }}</span>
              <span v-else>{{
                col.label == "Pode Retirar?" ? "" : col.label
              }}</span>
            </q-th>
          </q-tr>
        </template>
        <template #body-cell-selecionar="props">
          <q-td :props="props">
            <q-btn
              round
              no-caps
              color="red"
              dense
              icon="close"
              @click="removerProduto(props.row.id)"
            />
          </q-td>
        </template>
        <template #body-cell-imagem="props">
          <q-td :props="props">
            <div
              v-if="props.row.product_images.length != 0"
              class="img-container"
            >
              <q-img
                v-if="props.row.product_images.length != 0"
                :src="props.row.product_images[0].url"
                fit="contain"
                style="max-width: 100%; height: 45px"
              />
            </div>
            <div class="img-container" v-else>
              <span class="img-normal"></span>
            </div>
          </q-td>
        </template>
        <template #body-cell-codigo="props">
          <q-td :props="props">
            <span>{{ props.row?.code }}</span>
          </q-td>
        </template>
        <template #body-cell-nome="props">
          <q-td :props="props">
            <span>{{
              props.row?.pivot && props.row?.pivot.contract_product_description
                ? props.row?.pivot.contract_product_description
                : props.row?.name
            }}</span>
          </q-td>
        </template>
        <template #body-cell-estoque="props">
          <q-td :props="props">
            <span>{{
              parseInt(props.row?.stock[0]?.pivot.amount).toFixed(2)
            }}</span>
          </q-td>
        </template>
        <template #body-cell-ca_codigo="props">
          <q-td :props="props">
            <span>{{ props.row.ca_codigo }}</span>
          </q-td>
        </template>
        <template #body-cell-endereco="props">
          <q-td :props="props">
            <span>{{ props.row.endereco }}</span>
          </q-td>
        </template>
        <template
          v-if="filtroTipoRequisicao == 'liberados'"
          #body-cell-retirar="props"
        >
          <q-td>
            <span>{{ compararData(props.row, props.row.pode_retirar) }}</span>
          </q-td>
        </template>
        <template #body-cell-retiradas="props">
          <q-td :props="props">
            <q-btn
              icon="manage_search"
              flat
              color="black"
              round
              @click="
                (item = { nome: props.row.name, id: props.row.code }),
                  atualizarHistorico++
              "
            />
          </q-td>
        </template>

        <template #body-cell-quantidade="props">
          <q-td :props="props">
            <div>
              <q-input
                v-model.number="props.row.amount"
                type="number"
                style="width: 60px; max-width: 100px"
                outlined
                dense
                min="0"
              />
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <div
      class="row q-mt-lg text-brand-5 text-weight-bold text-body container-observacao"
    >
      <div class="col-8 text-area-input">
        <div
          style="font-weight: 100"
          class="q-ml-sm text-brand-1 no-margin-no-padding"
        >
          Observações
        </div>
        <q-input
          type="textarea"
          dense
          outlined
          v-model="requisicaoObservacao"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
            'vouchers-razao-criacao'
          ) != -1
        "
        class="q-mt-lg text-brand-5 text-weight-bold"
      >
        <span
          style="font-weight: 100"
          class="row col-12 text-brand-1 texto-autenticacao"
          >Selecione o Motivo para a Solicitação dessa requisição
          <span style="color: #8a8a8a" class="q-ml-sm">(Opcional)</span></span
        >
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Perda"
          val="Perda"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Roubo"
          val="Roubo"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            !$store.state.autenticacao.cliente.includes('acciona') &&
            !$store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Desgaste Natural"
          val="Desgaste Natural"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-model="dados.motivoRequisicao"
          label="Desgaste Precoce"
          val="Desgaste Precoce"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Possivel Defeito de Fabricação"
          val="Possivel Defeito de Fabricação"
          :size="mobile ? 'sm' : 'lg'"
        />
        <q-radio
          v-if="
            $store.state.autenticacao.cliente.includes('acciona') &&
            $store.state.autenticacao.cliente.includes('staging-acciona')
          "
          v-model="dados.motivoRequisicao"
          label="Atividade Emergencial"
          val="Atividade Emergencial"
          :size="mobile ? 'sm' : 'lg'"
        />

        <q-radio
          v-model="dados.motivoRequisicao"
          label="Outros"
          val="Outros"
          :size="mobile ? 'sm' : 'lg'"
        />
      </div>
      <div
        v-if="dados.motivoRequisicao == 'Outros'"
        class="col-md-8 col-sm-6 col-xs-6"
      >
        <div class="texto-titulo-input">Digite o motivo da retirada</div>
        <q-input
          v-model="dados.motivoRequisicaoOutros"
          dense
          outlined
          class="select"
        />
      </div>
      <div class="row col-12 q-mt-md btn-requisicao-container">
        <q-btn
          class="btn-requisicao"
          label="Abrir Requisição"
          no-caps
          :disable="criarRequisicao"
          style="background-color: #21324a; border-radius: 8px; color: white"
          icon="add"
          @click="abrirRequisicao()"
        />
      </div>
    </div>

    <TabelaHistoricoRetirada
      :solicitanteId="solicitanteMatricula"
      :item="item"
      :atualizar="atualizarHistorico"
    />
    <dialog-confirm
      mensagem="Esse produto ou quantidade está fora do prazo de entrega. Tem certeza que deseja continuar?"
      :exibir="aviso"
      :propsClass="'q-pa-md'"
      @resultado="adicionarLinha"
    >
    </dialog-confirm>
  </div>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

import DialogConfirm from "../components/DialogConfirm.vue";
import TabelaHistoricoRetirada from "./TabelaHistoricoRetirada.vue";
import { watchDebounced } from "@vueuse/core";
// import SelecaoCentroCustos from "../../legado/compras/components/SelectCentroCustos.vue";

const columns2 = [
  {
    name: "selecionar",
    label: "Remover",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "imagem",
    label: "Imagem",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: (row) => row.pivot.contract_product_description,
    sortable: true,
    style: "white-space: normal",
  },
  {
    name: "ca_codigo",
    label: "CA",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "estoque",
    label: "Estoque",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "quantidade",
    label: "QTD",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
  {
    name: "retiradas",
    label: "Retiradas",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "retirar",
    label: "Pode Retirar?",
    align: "left",
    sortable: false,
    style: "white-space: normal",
  },
];

export default {
  name: "NovaRequisicaoTabelas",
  props: {
    unidade: {
      type: Number,
      require: true,
    },
    filtroTipoRequisicao: {
      type: String,
      require: true,
    },
    tipoRequisicao: {
      type: String,
      require: true,
    },
    requisicaoPara: {
      type: String,
      require: false,
    },
    solicitantePesquisaProp: {
      type: String,
      require: false,
    },
    solicitanteMatriculaProp: {
      require: false,
    },
    centroSelecionadoProps: {
      require: false,
    },
    category: {
      type: Number,
      require: false,
    },
    tipoSaldo: {
      type: String,
      require: false,
    },
    isAll: {
      type: Boolean,
      require: false,
    },
  },
  components: { TabelaHistoricoRetirada, DialogConfirm },
  setup(props, { emit }) {
    const columns = ref([
      {
        name: "selecionar",
        label: "Selecionar",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "imagem",
        label: "Imagem",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "codigo",
        label: "Código",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "nome",
        label: "Nome",
        field: (row) => row.pivot.contract_product_description,
        align: "left",
        sortable: true,
        style: "white-space: normal",
      },
      {
        name: "ca_codigo",
        label: "CA",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "ca_status",
        label: "Status",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "endereco",
        label: "Endereço",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "critico",
        label: "Critico",
        align: "left",
        style: "white-space: normal",
      },
      {
        name: "estoque",
        label: "Estoque",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "quantidade",
        label: "QTD",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
      {
        name: "retirar",
        label: "Pode Retirar?",
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },
    ]);
    const store = useStore();
    const atualDate = ref(new Date().toLocaleString("pt-br"));
    const router = useRouter();
    const quasar = useQuasar();
    const filtroSolicitante = ref();
    const listaSolicitantes = ref([]);
    const solicitanteMatricula = ref(null);
    const listaProdutos = ref([]);
    const filtrarProduto = ref("");
    const filtroCACodigo = ref("");
    const filtroCAStatus = ref(null);
    let loading = ref(false);
    const listaProdutosSelecionados = ref([]);
    const selected = ref([]);
    const grupoProduto = ref("");
    const disable = ref(false);
    const aviso = ref(false);
    const dados = ref({
      motivoRequisicao: "",
      motivoRequisicaoOutros: undefined,
    });
    const linha = ref(null);
    const quantidadeProduto = ref(0);
    const listaCentros = ref([]);
    const centroSelecionado = ref(props.centroSelecionadoProps);
    const criarRequisicao = ref(false);
    const requisicaoObservacao = ref();
    const visitanteId = ref(null);
    const listarTodos = ref(true);
    const userLogadoId = ref();
    const item = ref({ nome: "", id: "" });
    const atualizarHistorico = ref(0);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 10,
    });
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarSolicitantes = async (valueSolicitante = null) => {
      await store.state.autenticacao.cliente;
      if (props.requisicaoPara == "visitante") {
        let response = await store.dispatch("requisicao/listarSolicitante", {
          per_page: 1,
          search: "visitante@multpex.com.br",
        });
        if (response.data.results.data.length == 0) {
          quasar.notify({
            message: "Usuario visitante não encontrado",
            color: "negative",
            actions: [
              {
                label: "fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        visitanteId.value = response.data.results.data[0].id;
        listaSolicitantes.value = response.data.results.data;
        solicitanteMatricula.value = listaSolicitantes.value[0];
        return;
      }
      let response = await store.dispatch("requisicao/listarSolicitante", {
        vendor_id:
          store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("vale-epiexpress")
            ? ""
            : props.unidade,
        per_page: 5,
        search: valueSolicitante ? valueSolicitante : filtroSolicitante.value,
      });
      listaSolicitantes.value = response.data.results.data;
      emit("listaSolicitantes", listaSolicitantes.value);
    };

    const listarCentros = async () => {
      let response = await store.dispatch("requisicao/listarCentrosCustos", {
        vendor_id: props.unidade,
        per_page: 16,
        search: filtroSolicitante.value,
      });

      listaCentros.value = response.data.results.data;
    };

    const listarProdutos = async () => {
      if (props.requisicaoPara == "visitante") {
        try {
          loading.value = true;
          let response = await store.dispatch("requisicao/listarProdutos", {
            vendor_id: props.unidade,
            per_page: 100,
            has_ca: props.filtroTipoRequisicao,
            search: filtrarProduto.value,
            category_id: props.category,
            saldo: props.tipoSaldo == "" ? undefined : props.tipoSaldo,
            ca: filtroCACodigo.value || undefined,
            ca_status: filtroCAStatus.value?.value,
          });

          let produtos = response.data.results.data.products;

          if (filtroCAStatus.value?.value) {
            produtos = produtos.filter((produto) => {
              const status = produto.ca_status || produto.pivot?.ca?.status;
              return status === filtroCAStatus.value.value;
            });
          }

          listaProdutos.value = produtos;
          loading.value = false;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (props.filtroTipoRequisicao != "liberados") {
        listaProdutos.value = [];
        loading.value = true;

        try {
          let response = await store.dispatch("requisicao/listarProdutos", {
            vendor_id: props.unidade,
            per_page: 100,
            has_ca: props.filtroTipoRequisicao,
            search: filtrarProduto.value,
            plantiff_id:
              props.tipoRequisicao == "requisicaoMaterial"
                ? solicitanteMatricula.value?.id
                : solicitanteMatricula.value?.idTabela,
            category_id: props.category,
            saldo: props.tipoSaldo == "" ? undefined : props.tipoSaldo,
            ca: filtroCACodigo.value || undefined,
            ca_status: filtroCAStatus.value?.value,
          });

          let produtos = response.data.results.data.products;

          if (filtroCAStatus.value?.value) {
            produtos = produtos.filter((produto) => {
              const status = produto.ca_status || produto.pivot?.ca?.status;
              return status === filtroCAStatus.value.value;
            });
          }

          produtos.forEach((e) => {
            listaProdutos.value.push({
              ...e,
              ca_codigo: e?.pivot?.ca?.code,
              ca_status: e?.pivot?.ca?.status,
            });
          });

          loading.value = false;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (props.filtroTipoRequisicao == "liberados") {
        loading.value = true;
        try {
          let response = await store.dispatch(
            "requisicao/listarProdutosLiberados",
            {
              vendor_id: props.unidade,
              per_page: 100,
              user_id:
                solicitanteMatricula.value?.idTabela ||
                solicitanteMatricula.value?.id,
              search: filtrarProduto.value,
              category_id: props.category,
              saldo: props.tipoSaldo == "" ? undefined : props.tipoSaldo,
              ca: filtroCACodigo.value || undefined,
              ca_status: "",
            }
          );

          pagination.value.rowsPerPage = response.data.per_page;
          pagination.value.rowsNumber = response.data.total;
          pagination.value.page = response.data.current_page;

          let novoResponse = response.data.data.map((e) => {
            return {
              name: e.descricao,
              product_images: [{ url: e.produto_url }],
              stock: [{ pivot: { amount: e.estoque } }],
              code: e.produto_codigo,
              id: e.produto_id,
              pode_retirar: e.pode_retirar,
              critico: e.critico,
              max_amount: e.max_amount,
              withdrawal_amount: e.withdrawal_amount,
              next_maximum_withdrawal: e.next_maximum_withdrawal,
              next_minimum_withdrawal: e.next_minimum_withdrawal,
              ca_codigo: e.ca_codigo || e?.pivot?.ca?.code,
              ca_status: e.ca_status,
              endereco: e?.endereco,
            };
          });

          if (filtroCAStatus.value?.value) {
            novoResponse = novoResponse.filter((produto) => {
              return produto.ca_status === filtroCAStatus.value.value;
            });
          }

          listaProdutos.value = novoResponse;
          loading.value = false;
        } catch (error) {
          console.log(error);
        }
        return;
      }
    };

    const removerProduto = async (id) => {
      selected.value = selected.value.filter((produto) => produto.id != id);
    };

    const abrirRequisicao = async () => {
      criarRequisicao.value = true;
      if (
        props.unidade == "218" &&
        (store.state.autenticacao.cliente[0] == "staging-vale" ||
          store.state.autenticacao.cliente[0] == "vale-epiexpress")
      ) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione outro posto para a criação da requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (
        props.unidade == "1" &&
        (store.state.autenticacao.cliente[0] == "cbmsa" ||
          store.state.autenticacao.cliente[0] == "staging-cbmsa")
      ) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione outro posto para a criação da requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (props.unidade == "" || !props.unidade) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Selecione uma Unidade para criar a Requisição.",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("requisicao/criarRequisicao", {
          cost_center_id:
            props.tipoRequisicao == "balcao" &&
            props.requisicaoPara == "visitante"
              ? centroSelecionado.value?.id
              : solicitanteMatricula.value.centroCusto,
          description: requisicaoObservacao.value,
          plantiff_id:
            props.tipoRequisicao == "balcao" &&
            props.requisicaoPara == "visitante"
              ? visitanteId.value
              : solicitanteMatricula.value?.idTabela ||
                solicitanteMatricula.value.id,
          products: selected.value,
          vendor_id: props.unidade,
          voucher_reason:
            dados.value.motivoRequisicao != ""
              ? dados.value.motivoRequisicao == "Outros"
                ? dados.value.motivoRequisicaoOutros
                : dados.value.motivoRequisicao
              : undefined,
        });
        resetarValores();
        quasar.notify({
          message: "Requisição feita com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        criarRequisicao.value = false;
        router.push({ name: "requisicao-lista" });
      } catch (error) {
        criarRequisicao.value = false;
        quasar.notify({
          message: "Erro ao abrir Requisição",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    const userLogado = async () => {
      let response = await store.dispatch("requisicao/userLogado");
      userLogadoId.value = response.data;
    };

    const resetarValores = async () => {
      requisicaoObservacao.value = "";
      selected.value = [];
      listaProdutos.value = [];
    };

    const compararData = (data, pode_retirar) => {
      if (pode_retirar == "Sim") {
        if (
          data.next_minimum_withdrawal == undefined ||
          data.next_minimum_withdrawal == null
        ) {
          return `Sim: (${parseFloat(data?.max_amount)})`;
        }

        let dataPrincipal = data.next_minimum_withdrawal.split(" ")[0];
        var partesData = dataPrincipal.split("-");

        var dataProximaRetirada = new Date(
          partesData[0],
          partesData[1] - 1,
          partesData[2]
        );

        if (dataProximaRetirada <= new Date()) {
          return `Sim (${parseFloat(data?.max_amount)})`;
        } else {
          return parseFloat(data?.max_amount) -
            parseFloat(data?.withdrawal_amount) ==
            0
            ? `Sim (0)`
            : `Sim: (${
                parseFloat(data?.max_amount) -
                parseFloat(data?.withdrawal_amount)
              })`;
        }
      } else if (pode_retirar == "Não") {
        return `Não: (0)`;
      }
    };

    const escolherLista = async () => {
      if (props.tipoRequisicao == "requisicaoMaterial") {
        solicitanteMatricula.value = userLogadoId.value;
      }

      if (
        props.filtroTipoRequisicao == null ||
        props.filtroTipoRequisicao == undefined ||
        props.filtroTipoRequisicao == ""
      ) {
        listaProdutos.value = [];
        return;
      }

      if (
        props.requisicaoPara == "colaborador" &&
        (props.solicitanteMatriculaProp == "" ||
          props.solicitanteMatriculaProp == undefined)
      ) {
        return;
      }
      if (
        (props.filtroTipoRequisicao == "liberados" &&
          solicitanteMatricula.value != null) ||
        props.tipoRequisicao == "requisicaoMaterial"
      ) {
        listarProdutos();
        return;
      }
      if (
        props.tipoRequisicao == "balcao" &&
        solicitanteMatricula.value != null &&
        props.filtroTipoRequisicao != null
      ) {
        listarProdutos();
        return;
      }
      if (props.requisicaoPara == "visitante") {
        listarProdutos();
        return;
      }
    };

    const compararDataCritico = (data) => {
      if (
        data.next_maximum_withdrawal == undefined ||
        data.next_maximum_withdrawal == null
      ) {
        return true;
      }

      let dataPrincipal2 = data.next_maximum_withdrawal.split(" ")[0];
      var partesData2 = dataPrincipal2.split("-");

      var dataProximaRetiradaMaxima = new Date(
        partesData2[0],
        partesData2[1] - 1,
        partesData2[2]
      );

      if (dataProximaRetiradaMaxima < new Date()) {
        return true;
      } else {
        return false;
      }
    };

    const hiddenColumns = () => {
      columns.value.pop();
    };

    const temPermissaoBuscaCA = () => {
      return (
        store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          "voucher-busca-ca"
        ) != -1
      );
    };

    watch(
      () => solicitanteMatricula.value,
      () => {
        if (props.tipoRequisicao == "requsicaoMaterial") {
          return;
        }
        selected.value = [];
        escolherLista();
      }
    );

    watch(
      () => props.solicitantePesquisaProp,
      () => {
        listarSolicitantes(props.solicitantePesquisaProp);
      }
    );

    watch(
      () => props.solicitanteMatriculaProp,
      () => {
        solicitanteMatricula.value = props.solicitanteMatriculaProp;
        if (
          props.solicitanteMatriculaProp == undefined ||
          props.solicitanteMatriculaProp == null ||
          props.solicitanteMatriculaProp == ""
        ) {
          listaProdutos.value = [];
          selected.value = [];
        }
      }
    );

    watch(
      () => centroSelecionado.value,
      () => {
        selected.value = [];
        escolherLista();
      }
    );

    watch(
      () => props.tipoRequisicao,
      () => {
        solicitanteMatricula.value = null;
        selected.value = [];
        centroSelecionado.value = null;
        escolherLista();
      }
    );

    watch(
      () => props.tipoSaldo,
      () => {
        listaProdutos.value = [];
        selected.value = [];
        escolherLista();
      }
    );

    watchDebounced(
      () => filtrarProduto.value,
      () => {
        escolherLista();
      },
      { debounce: 1000 }
    );

    watch(
      () => props.filtroTipoRequisicao,
      () => {
        if (
          props.filtroTipoRequisicao === null ||
          props.filtroTipoRequisicao === undefined
        ) {
          listaProdutos.value = [];
          selected.value = [];
          filtrarProduto.value = "";
          return;
        }

        if (
          props.filtroTipoRequisicao == "yes" ||
          (props.filtroTipoRequisicao == "all" && columns.value.length >= 9)
        ) {
          columns.value.pop();
        } else if (
          props.filtroTipoRequisicao == "liberados" &&
          columns.value.length <= 8
        ) {
          columns.value.push({
            name: "retirar",
            label: "Pode Retirar?",
            align: "left",
            sortable: false,
            style: "white-space: normal",
          });
        }

        selected.value = [];
        filtrarProduto.value = "";
        escolherLista();
      }
    );

    watch(
      () => filtroSolicitante.value,
      () => {
        listarSolicitantes();
      }
    );

    watch(
      () => props.requisicaoPara,
      () => {
        selected.value = [];
        listaProdutos.value = [];
      }
    );

    watch(
      () => listarTodos.value,
      () => {
        escolherLista();
      }
    );

    watch(
      () => props.centroSelecionadoProps,
      () => {
        centroSelecionado.value = props.centroSelecionadoProps;
      }
    );

    watch(
      () => props.unidade,
      () => {
        listaProdutos.value = [];
        selected.value = [];
        escolherLista();
      }
    );

    watch(
      () => filtroCACodigo.value,
      () => {
        escolherLista();
      }
    );

    watch(
      () => filtroCAStatus.value,
      () => {
        escolherLista();
      }
    );

    onMounted(async () => {
      await userLogado();

      if (props.isAll) {
        hiddenColumns();
      }
      listarCentros();
      listarSolicitantes();

      escolherLista();
    });

    const verificarQuantidade = async (row, props) => {
      if (props.selected) {
        props.selected = !props.selected;
        return;
      }

      const retirado =
        row.withdrawal_amount != null ? row.withdrawal_amount : 0;

      const valorMaximo = row?.max_amount?.replace(".", "");

      let dataPrincipal = row?.next_minimum_withdrawal?.split(" ")[0];
      var partesData = dataPrincipal ? dataPrincipal.split("-") : null;

      var newData =
        partesData != null
          ? new Date(partesData[0], partesData[1] - 1, partesData[2])
          : null;

      const verificarData =
        newData <= new Date()
          ? parseFloat(valorMaximo)
          : parseFloat(valorMaximo) - parseFloat(retirado) != 0
          ? parseFloat(valorMaximo) - parseFloat(retirado)
          : 0;

      /* eslint-disable-next-line */
      if (
        parseFloat(row.amount) > parseFloat(verificarData) ||
        row.pode_retirar == "Não"
      ) {
        aviso.value = true;
        linha.value = props;
      } else {
        props.selected = !props.selected;
      }
    };

    const verificarQuantidadeHttp = async (row, value) => {
      if (value.selected) {
        value.selected = !value.selected;
        value.row.loadingButton = false;
        return;
      }

      const response = await store.dispatch(
        "requisicao/verificaQuantidadedHttp",
        {
          productId: row.id,
          userId:
            props.tipoRequisicao == "requisicaoMaterial"
              ? solicitanteMatricula.value.id
              : solicitanteMatricula.value.idTabela,
        }
      );

      const retirado =
        response?.data?.results[0].withdrawal_amount != null
          ? response?.data?.results[0].withdrawal_amount
          : 0;

      const valorMaximo =
        response?.data?.results[0].max_amount != null
          ? response?.data?.results[0].max_amount
          : 0;

      let dataPrincipal =
        response?.data?.results[0].next_minimum_withdrawal != null
          ? row?.next_minimum_withdrawal?.split(" ")[0]
          : false;
      var partesData = dataPrincipal ? dataPrincipal.split("-") : null;
      var newData =
        partesData != null
          ? new Date(partesData[0], partesData[1] - 1, partesData[2])
          : null;

      const verificarData =
        parseFloat(valorMaximo) - parseFloat(retirado) != 0
          ? parseFloat(valorMaximo) - parseFloat(retirado)
          : newData <= new Date()
          ? parseFloat(valorMaximo)
          : 0;

      row.quantidade = row.quantidade == undefined ? 0 : row.quantidade;

      // console.log(valorMaximo, retirado, verificarData, row);
      /* eslint-disable-next-line */
      if (
        parseFloat(row.quantidade) > parseFloat(verificarData) ||
        response?.data?.results[0].pode_retirar == "Não"
      ) {
        aviso.value = true;
        linha.value = value;
        value.row.loadingButton = false;
      } else {
        value.selected = !value.selected;
        value.row.loadingButton = false;
      }
      value.row.loadingButton = false;
    };

    const adicionarLinha = async (resultado) => {
      aviso.value = false;
      if (resultado) {
        linha.value.selected = !linha.value.selected;
      }
    };

    return {
      adicionarLinha,
      verificarQuantidade,
      columns,
      linha,
      filtroSolicitante,
      listarSolicitantes,
      listaSolicitantes,
      solicitanteMatricula,
      aviso,
      listarProdutos,
      listaProdutos,
      filtrarProduto,
      filtroCACodigo,
      filtroCAStatus,
      temPermissaoBuscaCA,
      verificarQuantidadeHttp,
      loading,
      listaProdutosSelecionados,
      grupoProduto,
      store,
      removerProduto,
      criarRequisicao,
      selected,
      quantidadeProduto,
      abrirRequisicao,
      disable,
      requisicaoObservacao,
      userLogado,
      escolherLista,
      atualDate,
      columns2,
      listaCentros,
      listarTodos,
      item,
      atualizarHistorico,
      centroSelecionado,
      compararDataCritico,
      mobile,
      compararData,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      dados,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
/* height of all previous header rows */
.img-container {
  border: 2px solid gray;
  border-radius: 5px;
  font-weight: bold;
  width: 50px;
  height: 50px;
}
.img-normal {
  max-width: 100%;
  height: 100%;
}
.texto-toggle {
  font-size: 14px;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
@media only screen and (max-width: 635px) {
  .container {
    margin: 30px 0 0 0;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-container {
    padding: 0;
    margin: 0;
  }
  .img-container-grid {
    border: 2px solid #b4b4b4;
    border-radius: 5px;
    font-weight: bold;
    width: 90px;
    height: 110px;
  }
  .img-grid {
    max-width: 100%;
    height: 100%;
  }
  .text-titulo-grupo {
    font-size: 14px !important;
    width: 300px;
    margin-bottom: 20px;
  }
  .input-search-grupo {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .radio-grupo-produto {
    font-size: 12px;
  }
  .container-radio-solicitante {
    max-width: 160px;
  }
  .input-search-table {
    padding: 0;
    margin: 0;
    width: 100%;
  }
  .container-texto-input-search {
    font-size: 14px !important;
    width: 100%;
    margin-bottom: 20px;
  }
  .btn-quantidade {
    font-size: 7px;
    width: 5px;
  }
  .input-quantidade {
    margin: 0px;
    padding-left: 11px;
    font-size: 14px;
  }
  .input-quantidade-container {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    height: 32px;
  }
  .text-area-input {
    width: 100%;
  }
  .btn-requisicao-container {
    margin: 15px 0 0 5px;
  }
  .btn-requisicao {
    margin: 0 8px 0 0;
    padding: 8px 10px 8px 5px;
    font-size: 13px !important;
    width: 171px;
    border-radius: 5px;
  }
  .container-observacao {
    margin: 20px 0px 0px 0px;
  }
  .titulo-input-unidade {
    font-size: 12px;
  }
  .titulo-input-tipo-requisicao {
    font-size: 12px;
  }
  .arrow {
    color: white;
    font-size: 25px;
    border-radius: 5px;
    cursor: pointer;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px 0px 0px;
  }
}

@media only screen and (max-width: 368px) {
  .arrow {
    color: white;
    font-size: 21px;
    border-radius: 5px;
    cursor: pointer;
  }
}
</style>
